// extracted by mini-css-extract-plugin
export default {"container":"SampleTypeItem_container__-wysc","item":"SampleTypeItem_item__123R5"};